module.exports = __webpack_public_path__ + "img/11.57c01eeb.png";